define('shared/util/providers/data/directDebit',[
    'shared/util/registers/DataProvider',
    'shared/util/checkout/directdebit',
    'shared/util/state',
    'shared/util/state/adapters/onChange',
    'shared/util/state/adapters/order',
    'shared/lib/RSVP'
],
function(DataProvider, ddUtil, state, onChangeAdapter, orderAdapter, RSVP){
    var done;
    var provider;
    var lastIsOneOfferOrderValue;

    function getOrderFromStateValues(values){
        if (values && values.length > 0) {
            return values[0];
        }
        else{
            return null;
        }
    }

    return {
        provide: function(){
            
            if ( done ) {
                return done;
            }

            done = RSVP.resolve()
                .then(function(){
                    return RSVP.all([
                        state.adapters.add(onChangeAdapter),
                        state.adapters.add(orderAdapter)
                    ]);
                })
                .then(function(){
                    return state.get('order');
                })
                .then(function(values) {
                    var order = getOrderFromStateValues(values);
                    lastIsOneOfferOrderValue = ddUtil.isOneOffOrder(order);

                    provider = {
                        id: 'directDebit',
                        value: function () {
                            return function () {
                                return {
                                    getMandateId: ddUtil.getMandateId,
                                    getMandateDate: ddUtil.getMandateDate,
                                    getLocalMandateDate: ddUtil.getLocalMandateDate,
                                    isOneOffOrder: function () { return lastIsOneOfferOrderValue; }
                                }
                            };
                        }
                    };
                    DataProvider.instance.register(provider);
                })
                .then(function(){
                    onChangeAdapter.on('change', function( key, value ){
                        if ( key == null ) {
                            return;
                        }

                        if ( provider == null ) {
                            return;
                        }

                        var keys = key.split('.');
                        var first = keys[0];

                        if ( first != 'order' ) {
                            return;
                        }

                        state.get('order').then(function(values){
                            var order = getOrderFromStateValues(values);
                            var newIsOneOfferOrderValue = ddUtil.isOneOffOrder(order);
                            if(newIsOneOfferOrderValue !== lastIsOneOfferOrderValue){
                                provider.emit(
                                    'change',
                                    'isOneOffOrder',
                                    function () { return newIsOneOfferOrderValue; }
                                );
                                lastIsOneOfferOrderValue = newIsOneOfferOrderValue;
                            }
                        });

                    });
                });

            return done;
        }
    };
});
